






























import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Dropdown from '@/components/common/Dropdown.vue';
import List from '@/components/list/List.vue';
import ListItem from '@/components/list/ListItem.vue';
import ListItemDivider from '@/components/list/ListItemDivider.vue';
import PortalIcon from '@/components/icons/PortalIcon.vue';

import LocaleMixin from '@/mixins/locale';

@Component({
  components: { Dropdown, ListItemDivider, ListItem, List, PortalIcon },
})
export default class LocaleSelect extends mixins(LocaleMixin) {
  @Prop({ type: Boolean })
  readonly icon!: boolean;

  handleLocale(locale: string) {
    this.setLocale(locale);
  }
}
